import * as Tone from 'tone';

// Bit crusher — reduce bit depth (1–8 bits) and optionally downsample for
// classic lo-fi / 8-bit / vintage sampler grit.

export default {
    id: 'bitcrusher',
    name: 'Crush',
    color: '#d19a66',
    create() {
        const node = new Tone.BitCrusher({ bits: 4, wet: 1 });
        return {
            node,
            params: [
                { label: 'Bits', min: 1, max: 8, step: 1,
                  get: () => node.bits.value, set: v => { node.bits.value = v; } },
                { label: 'Wet', min: 0, max: 1, step: 0.01,
                  get: () => node.wet.value, set: v => { node.wet.value = v; } },
            ],
            dispose() { node.dispose(); },
        };
    },
};
